import { useSnapshot } from 'valtio'
import React, { type ReactElement } from 'react'
import { proxySignIn } from '../../../proxySignIn'
import { ErrorDisplay } from '../../../../../../shared/components/ui/forms/ErrorDisplay'
import { SubmitButton } from '../../../../../../shared/components/ui/buttons/SubmitButton'
import UserIcon from '../../../../../../shared/components/ui/icons/UserIcon'
import AccountIdIcon from '../../../../../../shared/components/ui/icons/AccountIdIcon'
import PasswordIcon from '../../../../../../shared/components/ui/icons/PasswordIcon'
import { StandardIconInput } from '../../../../../../shared/components/ui/forms/StandardIconInput'
import { InputFieldType } from '../../../../../../shared/types/InputFieldType'
import { handleBlur, handleChange, handleFormSubmit } from './utils'
import { ForgotPasswordButton } from './components/ForgotPasswordButton'
import { FormFieldNamesEnum } from './formFieldNamesEnum'
import { ForgotMerchantButton } from './components/ForgotMerchantButton'

export function SignInForm (): ReactElement {
  const { allowSubmit, apiCallSignIn: { error, loading }, formErrors, formValues, showEmailError, showMerchantIdError, showPasswordError } = useSnapshot(proxySignIn)

  return (
    <form onSubmit={handleFormSubmit} className="flex flex-col justify-center items-center">
      {
        error &&
        (
          <div className="mb-4">
            <ErrorDisplay error={error} />
          </div>
        )
      }

      <div className="w-72">
        <StandardIconInput
          id="email"
          icon={UserIcon}
          value={formValues[FormFieldNamesEnum.Email] ?? ''}
          errorMessage={formErrors[FormFieldNamesEnum.Email] ?? ''}
          showError={showEmailError}
          placeholder="Email"
          onChange={handleChange(FormFieldNamesEnum.Email)}
          onBlur={handleBlur(FormFieldNamesEnum.Email)}
        />

        <StandardIconInput
          id="accountId"
          value={formValues[FormFieldNamesEnum.PPMerchantId] ?? ''}
          onChange={handleChange(FormFieldNamesEnum.PPMerchantId)}
          onBlur={handleBlur(FormFieldNamesEnum.PPMerchantId)}
          placeholder="Account ID"
          icon={AccountIdIcon}
          showError={showMerchantIdError}
          errorMessage={formErrors[FormFieldNamesEnum.PPMerchantId] ?? ''}
        />

        <StandardIconInput
          id="password"
          inputType={InputFieldType.Password}
          onChange={handleChange(FormFieldNamesEnum.Password)}
          onBlur={handleBlur(FormFieldNamesEnum.Password)}
          placeholder="Password"
          icon={PasswordIcon}
          errorMessage={formErrors[FormFieldNamesEnum.Password] ?? ''}
          showError={showPasswordError}
          value={formValues[FormFieldNamesEnum.Password] ?? ''}
        />

        <SubmitButton text="Submit" disabled={!allowSubmit} anyLoading={loading} widthFull />
        <div className="flex flex-row justify-around">
          <ForgotPasswordButton />
          <ForgotMerchantButton />
        </div>

      </div>
    </form>
  )
}
